import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CriticalErrorNavigationService {
  constructor(private readonly router: Router) { }

  navigateToHttpError(error: HttpErrorResponse, returnUrl?: string, message?: string): Promise<boolean> {
    if (error.status === 0) {
      return this.navigateToConnectionError(returnUrl);
    }

    if (error.status === 500) {
      return this.navigateToServerError(returnUrl, message);
    }

    if(error.status === 404) {
      return this.navigateToError(404, '/', message);
    }

    return this.navigateToError(error.status || 500, returnUrl, message);
  }

  navigateToError(code: number | string, returnUrl?: string, message?: string): Promise<boolean> {
    const normalizedReturnUrl = this.normalizeReturnUrl(returnUrl ?? this.router.url);

    const queryParams: Record<string, string> = { returnUrl: normalizedReturnUrl };
    if (message) {
      queryParams['msg'] = message;
    }

    return this.router.navigate(['/erro', String(code)], { queryParams });
  }

  navigateToServerError(returnUrl?: string, message?: string): Promise<boolean> {
    return this.navigateToError(500, returnUrl, message);
  }

  navigateToConnectionError(returnUrl?: string): Promise<boolean> {
    return this.navigateToError(0, returnUrl);
  }

  resolveFallbackUrl(returnUrl?: string | null): string {
    return this.normalizeReturnUrl(returnUrl);
  }

  private normalizeReturnUrl(returnUrl?: string | null): string {
    if (!returnUrl || returnUrl === '/erro' || returnUrl.startsWith('/erro/')) {
      return '/';
    }

    return returnUrl.startsWith('/') ? returnUrl : `/${returnUrl}`;
  }
}
